import axios from 'axios'
import {BaseResponse, Pagination, Response} from 'src/app/models'
import {IApproval, IApprovalQuery} from 'src/app/models/Job/Approval.model'

export const APPROVAL = '/api/v1/admins/approvals'

export const LIST_WAIT_APPROVAL_KEY = 'LIST_WAIT_APPROVAL_KEY'
export const TOTAL_APPROVAL_KEY = 'TOTAL_APPROVAL_KEY '

export const getListWaitApprovalJob = (params?: IApprovalQuery) => {
  return axios.get<BaseResponse<Pagination<IApproval[]>>>(`${APPROVAL}`, {
    params,
  })
}
export const getTotalApproval = () => {
  return axios.get<BaseResponse<Response<any>>>(`${APPROVAL}/total_approval`)
}

export const getDetailAgentHistory = (job_id?: string, agent_id?: string) => {
  return axios.get<BaseResponse<Response<any>>>(`${APPROVAL}/${job_id}/agent/${agent_id}`)
}
